<div class="changelog-dialog-container">

  <div class="changelog-header">
    <h3>{{project.projectType.name}} Record {{project.projectId}} Change Log</h3>
  </div>

  <div class="filter-panel">
    <div class="filters" [formGroup]="filterForm">

      <mat-form-field>
        <mat-label>Date Range</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="dateRangeFilter">
          @for (dateRange of dateRanges; track dateRange) {
            <mat-option [value]="dateRange">{{dateRange.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>User</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="userFilter" multiple>
          @for (user of users; track user) {
            <mat-option [value]="user">{{user.fullName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Hub Component</mat-label>
        <mat-select disableOptionCentering formControlName="hubComponentFilter" multiple>
          @for (component of hubComponents; track component) {
            <mat-option [value]="component">
              {{component}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>


    </div>
    <div class="reset-panel">
      <a href="javascript: void(0)" (click)="resetFilters()">
        Reset Filters
      </a>

    </div>

  </div>

  @if (changeLogEntries?.length) {
    <div class="results-panel" matSort matSortActive="actionDate" matSortDirection="desc"
      (matSortChange)="sortData($event)">
      <div class="results-header">
        <div mat-sort-header="actionDate">Date</div>
        <div mat-sort-header="user">User</div>
        <div>Action</div>
      </div>
      <div class="results-grid">
        @for (entry of changeLogEntries; track entry) {
          <div class="result-row">
            <div class="date">{{entry.actionDate | date:'dd-MMM-yyyy'}}</div>
            <div class="user">
              <a [href]="'/user/' + entry.userId">
                {{entry.userFullName}}
              </a>
            </div>
            <div class="action">{{entry.action}}</div>
          </div>
        }
      </div>
    </div>
  }

  @if (changeLogEntries?.length === 0) {
    <div class="no-results-panel">
      <div class="alert alert-info alert-styled-left">
        No Results Found
      </div>
    </div>
  }

  <div class="pager-panel">

    @if (searchResult && changeLogEntries?.length) {
      <app-hub-paginator [currentPage]="searchResult.page"
        [totalItems]="searchResult.filteredItemsCount" [totalPages]="searchResult.filteredPagesCount"
        (pageRequested)="pageRequested($event)">
      </app-hub-paginator>
    }

  </div>

  <div class="changelog-footer">
    <button (click)="close()">Close</button>
  </div>

</div>
